exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container {\n    width: 320px;\n    height: 340px;\n    background-color: #F5F5F5;\n    border-style: solid;\n    border-color: black;\n    border-width: 1px;\n    border-radius: 2px;\n    box-shadow: 4px 4px 2px darkgrey;\n    padding: 0;\n}\n\nbutton {\n    margin-right: 3px;\n}\n\nh5 {\n    font-size: medium;\n    font-weight: bold;\n    font-style: italic;\n    color: #007eb3;\n    padding-left: 10px;\n}\n\n.dd {\n    font-size: 12px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    padding-left: 10px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Grid/dateEditor.component.css
// module id = 444
// module chunks = 1